var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.235 20.164c-.47 0-.823-.118-1.176-.47l-1.883-1.648H6.119C3.882 18.046 2 16.164 2 13.93V7.118C2 4.882 3.882 3 6.118 3h11.764C20.118 3 22 4.882 22 7.118v11.281c0 .942-.823 1.765-1.765 1.765zM6.118 4.176a2.913 2.913 0 00-2.942 2.942v6.81a2.913 2.913 0 002.942 2.942h11.294c.117 0 .235 0 .353.118l2.117 1.882c.353.353.941.118.941-.47V7.117a2.913 2.913 0 00-2.94-2.942H6.117z",
    fill: "var(--color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.294 11.582a.898.898 0 01-.588-.235.898.898 0 01-.236-.588c0-.236.118-.47.236-.588a.923.923 0 011.294 0 .898.898 0 01.235.588c0 .235-.118.47-.235.588-.236.118-.471.235-.706.235zm4.706 0a.898.898 0 01-.588-.235.898.898 0 01-.235-.588c0-.236.117-.47.235-.588a.923.923 0 011.294 0 .899.899 0 01.236.588c0 .235-.118.47-.236.588-.235.118-.47.235-.706.235zm4.706 0a.899.899 0 01-.588-.235.899.899 0 01-.236-.588c0-.236.118-.47.236-.588a.923.923 0 011.294 0 .898.898 0 01.235.588c0 .235-.118.47-.235.588-.236.118-.47.235-.706.235z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.bfd5e7a90fa4f79deafbc9898d63f2b4.svg";
export { ForwardRef as ReactComponent };